export default function incrementLoopIndex(index) {
  return index + 1;
};
